import * as React from "react";
const SvgFiRrStoreLock = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-store-lock_svg__a)">
      <path
        fill="#062147"
        d="M12 11a1 1 0 0 1-1 1 3.99 3.99 0 0 1-3-1.357A3.99 3.99 0 0 1 5 12H4q-.519-.002-1-.126V20c0 1.103.897 2 2 2h4a1 1 0 1 1 0 2H5c-2.206 0-4-1.794-4-4v-9.357A3.98 3.98 0 0 1 0 8c0-.093 1.209-4.373 1.209-4.373A5.02 5.02 0 0 1 6.018 0h11.965a5.02 5.02 0 0 1 4.809 3.626l1.171 4.1a1 1 0 0 1-.688 1.236 1.006 1.006 0 0 1-1.236-.688l-1.171-4.099a3.01 3.01 0 0 0-2.885-2.176h-.982v2a1 1 0 1 1-2 0V2h-6v2a1 1 0 1 1-2 0V2h-.982a3.01 3.01 0 0 0-2.885 2.177L2.005 8.126C2.037 8.643 2.809 10 4.001 10h1c1.103 0 2-.897 2-2a1 1 0 1 1 2 0c0 1.103.897 2 2 2a1 1 0 0 1 1 1zm12 7v2c0 2.206-1.794 4-4 4h-4c-2.206 0-4-1.794-4-4v-2a4 4 0 0 1 2-3.463V13c0-2.206 1.794-4 4-4s4 1.794 4 4v1.537c1.195.693 2 1.985 2 3.463m-8-4h4v-1c0-1.103-.897-2-2-2s-2 .897-2 2zm6 4c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v2c0 1.103.897 2 2 2h4c1.103 0 2-.897 2-2zm-4-.5a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 18 17.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-store-lock_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrStoreLock;
